import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-seat-map-flight-placeholder',
  templateUrl: './seat-map-flight-placeholder.component.html',
  styleUrls: ['./seat-map-flight-placeholder.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SeatMapFlightPlaceholderComponent {

  public Letters: string[] = ['A', 'B', 'C', null, 'D', 'E', 'F'];
  
  constructor() { }

}
